export { InjectionMode, Stylesheet, concatStyleSets, fontFace, keyframes, mergeStyleSets, mergeStyles } from '@uifabric/merge-styles/lib/index';
//# sourceMappingURL=MergeStyles.js.map